import { render, staticRenderFns } from "./general-insurance.vue?vue&type=template&id=06ea8d98"
import script from "./general-insurance.vue?vue&type=script&lang=ts"
export * from "./general-insurance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports